
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';
    import cliente from './barra-cliente.vue';
    //import ventas from './ventas/barra-ventas.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            cliente,
            //ventas,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {

        }

        Atras()
        {
            this.Controlador.CerrarChatActivo();
        }
    }
